import type { FinisherDataTransferObject } from '@mobi/api-types/racePage/types'
import type { IObservableFinisher } from '../Model/Observables/IObservableFinisher'
import ObservableTrotFinisher from '../Model/Observables/ObservableTrotFinisher'
import { BaseFinisherCodeBuilder } from './BaseFinisherCodeBuilder'

export default class TrotFinisherBuilder extends BaseFinisherCodeBuilder {
  build(dto: FinisherDataTransferObject): IObservableFinisher {
    const model = super.addBaseInformation(
      new ObservableTrotFinisher(),
      dto
    ) as ObservableTrotFinisher
    model.template('trot-finishers-template')
    model.tag('Trot')
    model.handicap(dto.Handicap)
    return model
  }
}
